<template>
  <BModal
    id="modal-add-rekening"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    hide-footer
    hide-header
    @shown="loadBanks"
  >
    <div class="my-2 mx-1">
      <div class="text-center mb-2">
        <div class="font-semibold text-2xl text-black mb-1">
          Tambah Rekening
        </div>
        <div>Penambahan rekening bank untuk partner</div>
      </div>
      <div class="mb-1">
        <div class="mb-1">
          Nama Bank
        </div>
        <validation-provider
          #default="{errors}"
          name="Nama Bank"
          rules="required"
        >
          <v-select
            v-model="fieldAddBankName"
            label="name"
            :reduce="option => option.code"
            :options="banks"
            :filterable="true"
            :state="errors.length > 0 ? false : null"
            :clearable="false"
            placeholder="Ketik untuk mencari..."
            @input="changeFieldAddBank"
            @close="$refs.bankAccount.focus()"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          <small
            v-if="validateFieldAddBankName"
            class="text-danger"
          >*Pilih Bank dulu ya</small>
        </validation-provider>
      </div>
      <div class="mb-2">
        <div class="mb-1">
          No Rekening
        </div>
        <validation-provider
          #default="{errors}"
          name="No Rekening"
          rules="required"
        >
          <div class="d-block d-sm-flex">
            <b-form-input
              ref="bankAccount"
              v-model="fieldAddAccountNo"
              placeholder="Masukkan Nomor Rekening"
              :state="errors.length > 5 ? false:null"
              maxlength="20"
              @keypress="isNumber($event)"
              @paste.prevent="AccountBankNo"
              @input="changeFieldAddBank"
            />
            <b-button
              :variant="fieldAddAccountName !== '' || ValidateAccountName ? 'secondary' : 'primary'"
              :disabled="fieldAddAccountName !== '' || ValidateAccountName"
              class="ml-1 cekRekening"
              @click="getAccount"
            >
              <b-spinner
                v-if="ValidateAccountName"
                variant="light"
                style="width: 23px; height: 23px"
              />
              <span v-else>{{ btnValidateCheck }}</span>
            </b-button>
          </div>
          <small
            v-if="validateFieldAddAccountNo"
            class="text-danger"
          >No Rekening harus diisi </small>
          <small class="text-danger">{{ validateLength }} </small>
          <small
            v-if="messageSameNoBank !== ''"
            class="text-danger"
          >{{ messageSameNoBank }}, </small>
        </validation-provider>
      </div>
      <div
        v-if="isValidateAccountName"
      >
        <b-form-group>
          <div class="d-flex">
            <div
              v-if="getValidateAccountName === 'COMPLETED'"
              class="validate-green py-[5px] px-[15px] d-flex"
            >
              <b-img
                rounded="circle"
                class="bg-[#34A770] mr-1 icon-validate"
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/Checklist.svg"
              />
              <span class="align-self-center text-black message-account-name">Nomor Rekening berhasil ditemukan</span>
            </div>
            <div
              v-if="getValidateAccountName === 'NOT_FOUND'"
              class="validate-red py-[5px] px-[15px] d-flex"
            >
              <b-img
                rounded="circle"
                class="bg-[#FFF2E2] mr-1 icon-validate"
                src="https://storage.googleapis.com/komerce/assets/icons/danger-yellow.svg"
              />
              <span class="align-self-center text-black message-account-name">Nomor Rekening salah/tidak ditemukan</span>
            </div>
          </div>
        </b-form-group>
      </div>
      <div class="mb-2">
        <div class="mb-1">
          Nama
        </div>
        <div class="d-flex">
          <b-form-input
            v-model="fieldAddAccountName"
            placeholder="Nama akan otomatis muncul disini"
            class="pr-2"
            disabled
          />
        </div>
        <small
          v-if="messageSameNameBank !== ''"
          class="text-danger"
        >{{ messageSameNameBank }}</small>
      </div>
      <div class="mb-2">
        <div class="mb-1 d-flex">
          <span>Dokumen Pendukung</span>
          <span class="text-danger">*</span>
          <span
            v-b-tooltip.hover="'Berisi bukti dari user yang telah disetujui oleh Ops'"
            class="k-info-circle-1 ml-[5px] text-[#08A0F7] align-self-center"
          />
        </div>
        <b-form-input
          v-model="fieldSupportingDoc"
          placeholder="Link dokumen pendukung"
          class="pr-2"
        />
        <div class="text-sm mt-[5px]">
          <span class="text-danger">*</span>
          <span>Wajib, diisi. Berisi tentang bukti-bukti dari user yang telah disetujui oleh Ops</span>
        </div>
      </div>
      <div class="w-full d-flex justify-center gap-4 pb-2 py-1">
        <b-button
          class="flex-[45%]"
          variant="outline-primary"
          @click="resetCondition()"
        >
          Batal
        </b-button>
        <b-button
          class="flex-[45%]"
          :variant="fieldAddBankName === '' || fieldAddAccountNo.length < 5 || fieldSupportingDoc.length < 5 ? 'secondary' : 'primary'"
          :disabled="fieldAddBankName === '' || fieldAddAccountNo.length < 5 || fieldSupportingDoc.length < 5"
          @click="updateBank()"
        >
          Simpan
        </b-button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { isNumber } from '@/libs/helpers'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: { ValidationProvider, vSelect },
  data() {
    return {
      required,
      isNumber,
      banks: [],
      fieldAddBankName: '',
      fieldAddAccountNo: '',
      fieldAddAccountName: '',
      fieldSupportingDoc: '',
      checkValidBank: true,
      messageSameNameBank: '',
      messageSameNoBank: '',
      ValidateAccountName: false,
      accountNameDB: false,
      validateLength: '',
      getValidateAccountName: false,
      isValidateAccountName: false,
      validateFieldAddBankName: false,
      validateFieldAddAccountNo: false,
      lenghtNoAccount: false,
      btnValidateCheck: 'Cek',
    }
  },
  methods: {
    loadBanks() {
      this.$http
        .get('xendit/disbursementbankAvailable')
        .then(({ data }) => {
          const exceptBanks = ['OVO', 'GOPAY', 'DANA', 'SHOPEEPAY', 'LINKAJA']
          this.banks = data.data.filter(bank => !exceptBanks.includes(bank.code))
        })
        .catch(() => {
          this.$toast_error({ message: 'Terjadi kesalahan saat pengambilan data bank' })
        })
    },
    changeFieldAddBank() {
      this.fieldAddAccountName = ''
      this.checkValidBank = true
      this.isValidateAccountName = false
      this.messageSameNoBank = ''
    },
    AccountBankNo(e) {
      this.fieldAddAccountNo = ''
      this.fieldAddAccountName = ''
      this.ValidateAccountName = false
      this.checkValidBank = true
      this.isValidateAccountName = false
      const dummyAccountBank = e.clipboardData.getData('text').replace(/\D/g, '')
      this.fieldAddAccountNo = dummyAccountBank
    },
    getAccount() {
      this.$refs.bankAccount.focus()
      if (this.fieldAddBankName !== '') {
        this.validateFieldAddBankName = false
        if (this.fieldAddAccountNo !== '') {
          this.validateFieldAddAccountNo = false
          if (this.fieldAddAccountNo.length >= 1 && this.fieldAddAccountNo.length < 5) {
            this.lenghtNoAccount = false
            this.validateLength = 'Minimal 5 angka ya, pastikan jenis bank sudah benar'
          } else {
            this.lenghtNoAccount = true
            this.validateLength = ''
            this.getAccountBank()
          }
        } else {
          this.validateFieldAddAccountNo = true
        }
      } else {
        this.validateFieldAddBankName = true
      }
    },
    getAccountBank() {
      this.ValidateAccountName = true
      this.$http_new.post('/auth/api/v1/bank-account/check-bank-owner',
        {
          bank_name: this.fieldAddBankName,
          bank_account_no: this.fieldAddAccountNo,
        }, {
          headers: { Authorization: `Bearer ${useJwt.getToken()}` },
        }).then(response => {
        this.isValidateAccountName = true
        if (response.data.data.status === 'COMPLETED') {
          this.btnValidateCheck = 'Cek'
          this.ValidateAccountName = false
          this.accountNameDB = true
          this.fieldAddAccountName = response.data.data.bank_account_name
          this.getValidateAccountName = response.data.data.status
          this.checkValidBank = false
        } else if (response.data.data.status === 'NOT_FOUND') {
          this.btnValidateCheck = 'Cek'
          this.ValidateAccountName = false
          this.checkValidBank = true
          this.getValidateAccountName = response.data.data.status
          this.fieldAddAccountName = ''
        } else {
          this.btnValidateCheck = 'Konfirmasi Cek'
          this.ValidateAccountName = false
          this.checkValidBank = true
          this.getValidateAccountName = response.data.data.status
          this.fieldAddAccountName = ''
        }
      }).catch(err => {
        this.isValidateAccountName = true
        this.ValidateAccountName = false
        this.checkValidBank = true
        this.fieldAddAccountName = ''
        this.getValidateAccountName = ''
        const { message } = err.response.data.meta
        const isValid = message.endsWith('Please use correct bank code')
        if (isValid) this.$toast_error({ message: 'Bank tidak didukung, silahkan menggunakan Bank lain' })
      })
    },
    updateBank() {
      const params = {
        bank_code: this.fieldAddBankName,
        bank_no: this.fieldAddAccountNo,
        bank_owner_name: this.fieldAddAccountName,
        supporting_link: this.fieldSupportingDoc,
      }
      this.$emit('on-confirm-button', params)
      this.resetCondition()
    },
    resetCondition() {
      this.fieldAddBankName = ''
      this.fieldAddAccountNo = ''
      this.fieldAddAccountName = ''
      this.fieldSupportingDoc = ''
      this.validateFieldAddBankName = false
      this.validateFieldAddAccountNo = false
      this.isValidateAccountName = false
      this.getValidateAccountName = false
      this.$bvModal.hide('modal-add-rekening')
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.validate-green {
  border: 1px solid #DCF3EB;
  background-color: #DCF3EB;
  width: 100%;
  border-radius: 8px;
}
.validate-red {
  border: 1px solid #FFF2E2;
  background-color: #FFF2E2;
  width: 100%;
  border-radius: 8px;
}
</style>
